(() => {
  const initialize = () => {
    const campaign = document.querySelector('[data-bf-campaign]');
    if (!campaign || campaign.dataset.initialized) return;
    campaign.dataset.initialized = 'true';
    const strings = JSON.parse(campaign.querySelector('[data-bf-strings]').textContent);
    const categories = [...document.querySelectorAll('[data-bf-category]')].map(section => ({section, key:section.dataset.bfKey, grid:section.querySelector('[data-bf-grid]'), entries:[], visible:8}));
    const initialCards = [...document.querySelectorAll('[data-bf-card]')];
    const initialById = new Map(initialCards.map(card => [card.dataset.productId, card]));
    const search = document.getElementById('bf-search');
    const sort = document.getElementById('bf-sort');
    const result = campaign.querySelector('[data-bf-results]');
    const root = window.Shopify?.routes?.root || '/';
    const currency = window.Shopify?.currency?.active || campaign.dataset.currency || 'USD';
    let formatter;
    try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}); }
    catch { formatter = new Intl.NumberFormat('en', {style:'currency',currency:'USD'}); }
    const money = value => formatter.format(value / 100);
    const start = Date.parse(campaign.dataset.start);
    const end = Date.parse(campaign.dataset.end);
    let entries = [];
    let mode = 'all';
    let active = 0;
    let catalogLoading = false;
    let searchTimer;
    const queue = [];
    const setData = (element, values) => Object.entries(values).forEach(([key,value]) => { element.dataset[key] = String(value); });
    const node = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };
    const linkFor = entry => `${root}products/${encodeURIComponent(entry.handle)}?variant=${entry.variant}`;
    const imageUrl = (source, width) => {
      if (!source) return '';
      try { const url = new URL(source, window.location.href); if (!['https:','http:'].includes(url.protocol)) return ''; url.searchParams.set('width',String(width)); return url.href; }
      catch { return ''; }
    };
    const buildCard = entry => {
      const card = node('article', `bf-card${entry.status === 'queued' || entry.status === 'loading' ? ' bf-card--loading' : ''}`);
      setData(card, {bfCard:'',title:entry.title.toLocaleLowerCase(),price:entry.loaded ? entry.price : '',saving:entry.loaded ? entry.saving : 0,offer:entry.loaded && entry.offer,index:entry.order,productId:entry.id,handle:entry.handle,variantId:entry.variant,loaded:entry.loaded});
      const media = node('a','bf-card__media');
      media.href = linkFor(entry);
      media.setAttribute('aria-label',entry.title);
      const src = imageUrl(entry.image,700);
      if (src) {
        const image = node('img');
        image.src = src;
        image.srcset = [240,360,500,700].map(width => `${imageUrl(entry.image,width)} ${width}w`).join(', ');
        image.sizes = '(min-width: 1000px) 23vw, (min-width: 600px) 30vw, 46vw';
        image.alt = entry.alt || entry.title;
        image.width = 700; image.height = 700; image.loading = 'lazy'; image.decoding = 'async';
        media.appendChild(image);
      }
      if (entry.loaded && entry.offer) media.appendChild(node('span','bf-card__badge',strings.save.replace('[percent]',String(entry.saving))));
      if (entry.loaded && !entry.available) media.appendChild(node('span','bf-card__unavailable',strings.soldOut));
      const body = node('div','bf-card__body');
      const heading = node('h3');
      const title = node('a','',entry.title); title.href = linkFor(entry); heading.appendChild(title); body.appendChild(heading);
      if (entry.loaded) {
        const prices = node('div','bf-card__price');
        prices.append(node('span','visually-hidden',strings.currentPrice),node('strong','',money(entry.price)));
        if (entry.offer) prices.append(node('span','visually-hidden',strings.comparePrice),node('s','',money(entry.compare)));
        body.append(prices,node('p',entry.offer ? 'bf-card__saving' : 'bf-card__regular',entry.offer ? `${strings.savingLabel} ${entry.saving}%` : strings.regular));
      } else body.appendChild(node('p','bf-card__loading',entry.status === 'error' ? strings.priceOnProduct : strings.loading));
      const action = node('a','bf-card__cta',strings.choose); action.href = linkFor(entry);
      const arrow = node('span','','↗'); arrow.setAttribute('aria-hidden','true'); action.appendChild(arrow);
      body.appendChild(action); card.append(media,body);
      card.classList.toggle('bf-card--after',campaign.dataset.phase === 'ended');
      return card;
    };
    const updateBanners = () => {
      document.querySelectorAll('[data-bf-artwork]').forEach(banner => {
        const href = banner.querySelector('a')?.getAttribute('href') || '';
        const target = href.startsWith('#bf-') ? document.getElementById(href.slice(1)) : null;
        banner.hidden = campaign.dataset.phase === 'ended' || Number(campaign.dataset.maximum) !== 50 || Boolean(target?.hidden);
      });
    };
    const updateHero = () => {
      const verified = entries.length ? entries.filter(entry => entry.loaded && entry.offer).map(entry => entry.saving) : initialCards.map(card => Number(card.dataset.saving));
      const maximum = Math.max(0,...verified);
      campaign.querySelector('[data-bf-maximum]').textContent = String(maximum);
      campaign.dataset.maximum = String(maximum);
      campaign.querySelector('[data-bf-offer]').hidden = campaign.dataset.phase === 'ended' || maximum === 0;
      const cover = campaign.querySelector('[data-bf-cover]');
      const showCover = Boolean(cover?.querySelector('img')) && campaign.dataset.phase !== 'ended';
      if (cover) cover.hidden = !showCover;
      campaign.querySelector('[data-bf-fallback-hero]').hidden = showCover;
    };
    const update = () => {
      const term = search.value.trim().toLocaleLowerCase();
      entries.forEach(entry => { entry.wanted = false; });
      let matchingCount = 0;
      categories.forEach(category => {
        const matching = category.entries.filter(entry => entry.title.toLocaleLowerCase().includes(term) && (mode === 'all' || entry.offer));
        matching.sort((a,b) => {
          if (sort.value === 'saving') return b.saving-a.saving || a.order-b.order;
          if (sort.value === 'price_asc') return a.sortPrice-b.sortPrice || a.order-b.order;
          if (sort.value === 'price_desc') return b.sortPrice-a.sortPrice || a.order-b.order;
          return a.order-b.order;
        });
        const desired = matching.slice(0,category.visible);
        desired.forEach(entry => {
          entry.wanted = true;
          if (entry.status === 'idle') { entry.status = 'queued'; queue.push(entry); }
          if (!entry.element) entry.element = buildCard(entry);
        });
        desired.forEach((entry,index) => {
          const current = category.grid.children[index];
          if (current === entry.element) return;
          if (current?.dataset.productId === entry.id) category.grid.replaceChild(entry.element,current);
          else category.grid.insertBefore(entry.element,current || null);
        });
        while (category.grid.children.length > desired.length) category.grid.lastElementChild.remove();
        category.section.hidden = matching.length === 0;
        matchingCount += matching.length;
        category.section.querySelector('[data-bf-category-count]').textContent = strings.count.replace('[count]',String(matching.length));
        const remaining = Math.max(0,matching.length-category.visible);
        const more = category.section.querySelector('[data-bf-more]');
        const busy = desired.some(entry => ['queued','loading'].includes(entry.status));
        const failed = desired.some(entry => entry.status === 'error');
        more.hidden = remaining === 0;
        more.disabled = busy;
        more.textContent = `${strings.moreItems.replace('[count]',String(Math.min(24,remaining)))} · ${strings.remaining.replace('[count]',String(remaining))}`;
        more.setAttribute('aria-expanded',String(category.visible > 8));
        category.section.querySelector('[data-bf-less]').hidden = category.visible <= 8 || matching.length <= 8;
        category.grid.setAttribute('aria-busy',String(busy));
        const status = category.section.querySelector('[data-bf-category-status]');
        status.hidden = !busy && !failed;
        status.textContent = failed ? strings.loadError : busy ? strings.loading : '';
        category.section.querySelector('[data-bf-retry]').hidden = !failed;
      });
      result.textContent = matchingCount ? strings.results.replace('[count]',String(matchingCount)) : strings.empty;
      updateHero(); updateBanners(); pump();
    };
    const applyProduct = (entry, product) => {
      if (String(product.id) !== entry.id) throw new Error('Product identity changed');
      const variants = Array.isArray(product.variants) ? product.variants : [];
      let chosen = variants.find(variant => String(variant.id) === String(entry.variant));
      if (!chosen?.available) chosen = variants.find(variant => variant.available) || variants[0];
      if (!chosen || !Number.isFinite(Number(chosen.price))) throw new Error('Product variant unavailable');
      entry.variant = String(chosen.id); entry.available = Boolean(chosen.available);
      entry.price = Number(chosen.price); entry.sortPrice = entry.price;
      entry.compare = Number(chosen.compare_at_price) || 0;
      const saving = entry.compare > entry.price ? Math.round((entry.compare-entry.price)*100/entry.compare) : 0;
      entry.offer = entry.available && saving >= 15 && saving <= 50;
      entry.saving = entry.offer ? saving : 0;
      entry.title = product.title || entry.title;
      entry.image = product.featured_image || product.images?.[0] || entry.image;
      entry.loaded = true; entry.status = 'ready'; entry.element = buildCard(entry);
    };
    const retrieve = async entry => {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(),12000);
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(entry.handle)}.js`,{credentials:'same-origin',signal:controller.signal});
        if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
        applyProduct(entry,await response.json());
      } finally { window.clearTimeout(timer); }
    };
    const pump = () => {
      while (active < 4 && queue.length) {
        const entry = queue.shift();
        if (!entry.wanted) { entry.status = 'idle'; entry.element = null; continue; }
        active += 1; entry.status = 'loading';
        retrieve(entry).catch(() => { entry.status = 'error'; entry.loaded = false; entry.offer = false; entry.saving = 0; entry.element = buildCard(entry); }).finally(() => { active -= 1; update(); });
      }
    };
    const resetVisible = () => categories.forEach(category => { category.visible = 8; });
    categories.forEach(category => {
      category.section.querySelector('[data-bf-more]').addEventListener('click',() => { category.visible += 24; update(); });
      category.section.querySelector('[data-bf-less]').addEventListener('click',() => { category.visible = 8; update(); category.section.scrollIntoView({block:'start',behavior:'auto'}); });
      category.section.querySelector('[data-bf-retry]').addEventListener('click',() => { category.entries.filter(entry => entry.status === 'error').forEach(entry => { entry.status = 'idle'; entry.element = null; }); update(); });
    });
    search.addEventListener('input',() => { window.clearTimeout(searchTimer); searchTimer = window.setTimeout(() => { resetVisible(); update(); },180); });
    sort.addEventListener('change',() => { resetVisible(); update(); });
    campaign.querySelectorAll('[data-bf-mode]').forEach(button => button.addEventListener('click',() => {
      mode = button.dataset.bfMode;
      campaign.querySelectorAll('[data-bf-mode]').forEach(item => { const selected = item === button; item.setAttribute('aria-pressed',String(selected)); item.classList.toggle('is-active',selected); });
      resetVisible(); update();
    }));
    const loadCatalog = async () => {
      if (catalogLoading) return;
      catalogLoading = true;
      campaign.querySelector('[data-bf-retry-catalog]').hidden = true;
      try {
        const response = await fetch(campaign.dataset.catalogUrl);
        if (!response.ok) throw new Error('Catalog request failed');
        const catalog = await response.json();
        if (!Array.isArray(catalog.products) || catalog.products.length !== catalog.count || new Set(catalog.products.map(item=>String(item.id))).size !== catalog.count) throw new Error('Invalid campaign index');
        const ratios = catalog.products.flatMap(item => { const card = initialById.get(String(item.id)); return card && item.price > 0 ? [Number(card.dataset.price)/item.price] : []; }).sort((a,b)=>a-b);
        const factor = currency === catalog.currency ? 1 : ratios[Math.floor(ratios.length/2)] || 1;
        entries = catalog.products.map((item,order) => {
          const card = initialById.get(String(item.id));
          return {...item,id:String(item.id),variant:card?.dataset.variantId || String(item.variant),order,price:card ? Number(card.dataset.price) : null,sortPrice:card ? Number(card.dataset.price) : item.price*factor,saving:card ? Number(card.dataset.saving) : item.saving,offer:card ? card.dataset.offer === 'true' : Boolean(item.offer),loaded:Boolean(card),available:true,status:card?'ready':'idle',element:card || null,wanted:false};
        });
        categories.forEach(category => { category.entries = entries.filter(entry => entry.category === category.key); });
        if (categories.reduce((sum,category)=>sum+category.entries.length,0) !== entries.length) throw new Error('Campaign category mismatch');
        campaign.querySelector('[data-bf-controls]').hidden = false;
        campaign.querySelector('[data-bf-offer-filters]').hidden = false;
        campaign.dataset.catalogReady = 'true';
        update();
      } catch {
        result.textContent = strings.catalogError;
        campaign.querySelector('[data-bf-retry-catalog]').hidden = false;
      } finally { catalogLoading = false; }
    };
    campaign.querySelector('[data-bf-retry-catalog]').addEventListener('click',loadCatalog);
    let previousPhase = '';
    const tick = () => {
      const now = Date.now();
      const phase = now >= end ? 'ended' : now >= start ? 'live' : 'upcoming';
      if (phase !== previousPhase) {
        previousPhase = phase; campaign.dataset.phase = phase;
        campaign.querySelector('[data-bf-status]').textContent = strings[phase];
        campaign.querySelector('[data-bf-primary]').firstChild.textContent = phase === 'ended' ? strings.current : phase === 'live' ? strings.shop : strings.preview;
        campaign.querySelector('[data-bf-clock]').hidden = phase === 'ended';
        document.querySelector('.bf-finish').hidden = phase === 'ended';
        document.querySelectorAll('[data-bf-card]').forEach(card => card.classList.toggle('bf-card--after',phase === 'ended'));
        updateHero(); updateBanners();
      }
      if (phase === 'ended') return;
      const seconds = Math.max(0,Math.floor(((phase === 'upcoming' ? start : end)-now)/1000));
      const values = {days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};
      Object.entries(values).forEach(([key,value]) => { campaign.querySelector(`[data-bf-${key}]`).textContent = String(value).padStart(2,'0'); });
    };
    tick();
    const interval = window.setInterval(() => { if (!document.body.contains(campaign)) window.clearInterval(interval); else tick(); },1000);
    loadCatalog();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
